<template>
  <div>
    <div><CustomLoader v-if="isLoading" :width="70"/></div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="'outline-primary'" @click="addContainerAllocation('Add',0)" style="font-size: 0.675rem"> Add</b-button>
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.CAFNoFilter ||
              Filter.caf_transport_typeFilter ||
              Filter.caf_tpt_typeFilter ||
              Filter.clientFilter ||
              Filter.driverFilter ||
              Filter.containerTypeFilter ||
              Filter.fromFilter ||
              Filter.toFilter ||
              Filter.billingForFilter ||
              Filter.CSTeamFilter ||
              Filter.contractNoFilter ||
              Filter.commodityHsnCodeFilter ||
              Filter.EMPFilter ||
              Filter.PORFilter ||
              Filter.POLFilter ||
              Filter.PODFilter ||
              Filter.FPODFilter ||
              Filter.statusFilter ||
              Filter.commonFilter ||
              Filter.createdByFilter ||
              Filter.updatedByFilter ||
              Filter.branchFilter ||
              Filter.createdAtRange.startDate ||
              Filter.createdAtRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.CAFNoFilter ||
                  Filter.caf_transport_typeFilter ||
                  Filter.caf_tpt_typeFilter ||
                  Filter.clientFilter ||
                  Filter.driverFilter ||
                  Filter.containerTypeFilter ||
                  Filter.fromFilter ||
                  Filter.toFilter ||
                  Filter.billingForFilter ||
                  Filter.CSTeamFilter ||
                  Filter.contractNoFilter ||
                  Filter.commodityHsnCodeFilter ||
                  Filter.EMPFilter ||
                  Filter.PORFilter ||
                  Filter.POLFilter ||
                  Filter.PODFilter ||
                  Filter.FPODFilter ||
                  Filter.statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdByFilter ||
                  Filter.updatedByFilter ||
                  Filter.branchFilter ||
                  Filter.createdAtRange.startDate ||
                  Filter.createdAtRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getContainerAllocationList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getContainerAllocationList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="6"> </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.createdAtRange"
                    :startDate="startDate" :endDate="endDate" :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getContainerAllocation('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>CAF NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search CAF NO Filter"
                    id="CAFNoFilter" name="CAFNoFilter" autocomplete="off" v-model="Filter.CAFNoFilter"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Transportation By</label>
                  <model-list-select :list="TPTtypeList" id="caf_tpt_typeFilter"
                    v-model="Filter.caf_tpt_typeFilter" option-value="ccTypeVal" option-text="ccTypeTxt"
                    placeholder="Select Transportation By"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Movement Type</label>
                  <model-list-select :list="movementTypeList" id="caf_transport_typeFilter"
                    v-model="Filter.caf_transport_typeFilter" option-value="val" option-text="text"
                    placeholder="Select Movement Type"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Container Type</label>
                  <model-list-select :list="$store.getters['common/getAllContainerTypeList']" v-model="Filter.containerTypeFilter" option-value="containerTypeId"
                    option-text="containerType" placeholder="Select Container Type"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>From</label>
                  <model-list-select :list="$store.getters['common/getAllPORList']" v-model="Filter.fromFilter" option-value="pickupId"
                    option-text="pickupLocation" placeholder="Select From"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Status</label>
                  <model-list-select :list="statusList" v-model="Filter.statusFilter" option-value="pTypeVal"
                    option-text="pTypeText" placeholder="Select Status"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>To</label>
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllStuffingList']" v-model="Filter.toFilter" option-value="pickupId"
                    option-text="pickupLocation" placeholder="Select To"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Driver Name</label>
                  <model-list-select :list="$store.getters['commonDropdownMaster/getAllDriverDDList']"
                    v-model="Filter.driverFilter" option-value="value" option-text="label"
                    placeholder="Select Driver Name"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Shipper</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Shipper Name"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" />
                </b-col>
              
               

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getContainerAllocation('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Created User" />
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getContainerAllocationList" :fields="CafFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">
                <!-- Default Row Data -->
                <template slot="SN" slot-scope="row0">
                  <span>
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}
                  </span>
                </template>

                <template slot="CreatedDate" slot-scope="row1">
                  <b-button class="pull-right ml-1 mt-1" :variant="'outline-primary'" @click="addContainerAllocation('Edit',row1.item)" style="font-size: 0.675rem">Edit</b-button>
                  <b-button v-if="row1.item.caf_pdf_url" class="pull-right ml-1 mt-1" :variant="'outline-warning'" @click="addContainerAllocation('View',row1.item)" style="font-size: 0.675rem">View Doc</b-button>
                  </template>
                
              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant";
import ToggleSwitch from "../../common/ToggleSwitch.vue";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    const storePromises = [
        this.$store.dispatch(
          "common/setAllClientList",
          JSON.stringify({ itemCode: "ClientList", isKYC: "Yes", isBRF: 0 })
        ),
        this.$store.dispatch(
          "common/setAllContainerTypeList",
          JSON.stringify({ itemCode: "ContainerTypeList" })
        ),
        this.$store.dispatch(
          "common/setAllShippingLineList",
          JSON.stringify({ itemCode: "ShippingLineList" })
        ),
        this.$store.dispatch(
          "common/setAllPORList",
          JSON.stringify({
            itemCode: "PORList",
          })
        ),
        this.$store.dispatch(
          "commonDropdownMaster/setAllVehicleDDList",
          JSON.stringify({
            itemCode: "getVehicleList",
            vehicleActiveInactiveId: "1",
          })
        ),
        this.$store.dispatch(
          "commonDropdownMaster/setAllDriverDDList",
          JSON.stringify({
            itemCode: "getDriverList",
            isDriverActive: "1",
          })
        ),];
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      Promise.all(storePromises)
        .then(() => delay(2000)) // Wait for 5 seconds
        .then(() => {
          // After the delay, execute the next function
       
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getContainerAllocation("Normal", "0", "0", "1", "1");
    }
        })
        .catch((error) => {
          console.error("Error dispatching store actions:", error);
        });
        this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
        lastVisitPage(this.$router.history.current.fullPath);

  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getContainerAllocationList: [],
      totalData: 0,

      CafFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "caf_no",
          mainkey: "caf_no",
          label: "CAF Details",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "caf_tpt_type",
          mainkey: "caf_tpt_type",
          label: "Transportation By",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "caf_transport_type",
          mainkey: "caf_transport_type",
          label: "Movement Type",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "caf_date",
          mainkey: "caf_date",
          label: "CAF Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "driverName",
          mainkey: "driverName",
          label: "Driver",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "containerType",
          mainkey: "containerType",
          label: "Container",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "FromLoc",
          mainkey: "FromLoc",
          label: "From",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ToLoc",
          mainkey: "ToLoc",
          label: "To",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "createdBy",
          mainkey: "createdBy",
          label: "Created By",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "CreatedDate",
          mainkey: "CreatedDate",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      statusList: [
        {
          pTypeVal: "0",
          pTypeText: "In-Active",
        },
        {
          pTypeVal: "1",
          pTypeText: "Active",
        },
        {
          pTypeVal: "2",
          pTypeText: "All",
        },
      ],
      
      transportTypeList: [
        {
          text: "EXPORT",
          value: "Export",
        },
        {
          text: "IMPORT",
          value: "Import",
        },
        {
          text: "CROSS COUNTRY",
          value: "CRC",
        },
      ],
      Filter: {
        CAFNoFilter: "",
        caf_transport_typeFilter: "",
        caf_tpt_typeFilter: "",
        clientFilter: "",
        driverFilter: "",
        containerTypeFilter: "",
        fromFilter: "",
        toFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      createdAtRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      isSubmited: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    ToggleSwitch,
  },
  computed: {},
  watch: {},
  methods: {
    addContainerAllocation(type, item) {
      this.$sessionsStorage.set("edit_caf_id", "");
      if(type=='Add'){

      }else if(type=='Edit'){
        this.$sessionsStorage.set("edit_caf_id", item.caf_id);
      }else if(type=='View'){
        if(!item.caf_pdf_url) return;
        this.openSignedDocument(`container_allocation/${item.caf_pdf_url}`);
        return;
      }
      this.$router.push({path: "/tpt/container-allocation",});
    },
    clearFilter() {
      this.Filter = {
        CAFNoFilter: "",
        caf_transport_typeFilter: "",
        caf_tpt_typeFilter: "",
        clientFilter: "",
        driverFilter: "",
        containerTypeFilter: "",
        fromFilter: "",
        toFilter: "",
        statusFilter: "2",
        commonFilter: "",
        createdByFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getContainerAllocation("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.createdAtRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getContainerAllocation(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.totalData = 0;
      this.getContainerAllocationList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getContainerAllocationList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data.data);
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              // const url = window.URL.createObjectURL(new Blob([data]));

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "Container-Allocation-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getContainerAllocation("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalContainerAllocations;
                this.getContainerAllocationList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getContainerAllocationList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getContainerAllocation("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getContainerAllocation("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContainerAllocation("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContainerAllocation("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// containerAllocationList.vue?3b1425d5